import { fetchConfirmedTrips } from '@/store/actions'
import { HeartFilledIcon, HeartIcon } from '@/style-guide'
import { makeAction } from '@/utils/apiEndpoints'
import { useDispatch, useSelector } from 'react-redux'

export const FavoriteAction = ({
  trip,
  trips = [],
  setLoading = () => {},
  setTrips = () => {},
  setTrip = () => {},
  isTripPage = false,
}) => {
  const { currentUser } = useSelector((state) => state.auth)
  const dispatch = useDispatch()
  const handleClickFavMethod = async () => {
    try {
      setLoading(true)
      await makeAction({
        tripId: trip._id,
        memberIds: [currentUser._id],
        action: trip.isFavorite ? 'makeUnFavorite' : 'makeFavorite',
      })
      if (isTripPage) {
        setTrip({ ...trip, isFavorite: !trip.isFavorite })
      } else {
        setTrips(
          trips.map((t) => {
            if (t._id === trip._id) {
              t['isFavorite'] = !trip?.isFavorite
            }
            return t
          })
        )
        if (!trip?.isFavorite) dispatch(fetchConfirmedTrips())
      }
    } catch (e) {
      // Error
    } finally {
      setLoading(false)
    }
  }
  return (
    <>
      {trip?.isFavorite ? (
        <HeartFilledIcon onClick={() => handleClickFavMethod(trip)} />
      ) : (
        <HeartIcon onClick={() => handleClickFavMethod(trip)} />
      )}
    </>
  )
}
